<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper" style="min-height: 307px">

    <!-- สินเชื่อ -->
    <section class="content">

        <ngx-spinner type="ball-beat"></ngx-spinner>
    
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">        
                    <div class="card card-prirary cardutline direct-chat direct-chat-primary">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-12 col-sm-6 col-md-3">
                                    <div class="info-box">
                                        <span class="info-box-icon bg-primary elevation-1">
                                            <i class="fas fa-file-upload"></i>
                                        </span>
                                        <div class="info-box-content">
                                            <span class="info-box-text headText">จำนวนคำขอเกี้ยวทั้งหมด</span>
                                            <span class="info-box-number headText3">
                                                {{ financeSummary.cntFn | number: '1.0-0'}} <small>รายการ</small> {{ financeSummary.moneyRequest | number }} <small>บาท</small>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6 col-md-3">
                                    <div class="info-box mb-3">
                                        <span class="info-box-icon bg-warning elevation-1">
                                        <i class="	fas fa-comments-dollar"></i>
                                        </span>
                    
                                        <div class="info-box-content">
                                        <span class="info-box-text headText">จำนวนคำขอรอเข้าระบบสินเชื่อ</span>
                                        <span class="info-box-number headText3">
                                            {{ financeSummary.cntZonestep | number: '1.0-0'}} <small>รายการ</small> {{ financeSummary.money_zonestep | number }} <small>บาท</small>
                                        </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6 col-md-3">
                                    <div class="info-box mb-3">
                                        <span class="info-box-icon bg-secondary elevation-1"><i class="fas fa-chalkboard-teacher"></i></span>
                    
                                        <div class="info-box-content">
                                        <span class="info-box-text headText">จำนวนคำขอในขั้นตอนสินเชื่อ</span>
                                        <span class="info-box-number headText3">
                                            {{ financeSummary.cntFnstep | number: '1.0-0'}} <small>รายการ</small> {{ financeSummary.money_fnstep | number }} <small>บาท</small>
                                        </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6 col-md-3">
                                    <div class="info-box mb-3">
                                        <span class="info-box-icon bg-success elevation-1"><i class="fas fa-thumbs-up"></i></span>
                    
                                        <div class="info-box-content">
                                            <span class="info-box-text headText">จำนวนคำขอที่อนุมัติแล้ว</span>
                                            <span class="info-box-number headText3">
                                                {{ financeSummary.cntFned | number: '1.0-0'}} <small>รายการ</small> {{ financeSummary.credit_approved | number }} <small>บาท</small>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
            
                            <span class="card-title headText3 text-primary">สรุปข้อมูลรายการขอเกี้ยว</span>
                            <button (click)="downloadExcel();" type="button" class="btn btn-tool" data-toggle="tooltip" title="Download Excel">
                                <i class="fas fa-file-excel"></i></button>
                            <div class="card-tools">
                                <!-- <span data-toggle="tooltip" title="3 New Messages" class="badge bg-primary">3</span> -->
                                <button (click)="downloadExcel();" type="button" class="btn btn-tool" data-toggle="tooltip" title="Download Excel">
                                    <i class="fas fa-file-excel"></i></button>
                                <button type="button" class="btn btn-tool" data-toggle="tooltip" title="show panel"
                                    data-widget="chat-pane-toggle"><i class="fas fa-angle-double-left"></i>
                                </button>
                                <button type="button" class="btn btn-tool" (click)="getFinanceData();"><i class="fas fa-sync"></i></button>
                                <button type="button" class="btn btn-tool" data-card-widget="maximize"><i class="fas fa-expand"></i></button>
                                <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i></button>
                            </div>
                        </div>
                        
                        <div class="row">
                            <!-- <div class="col-3">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                <span class="input-group-text">ปีการผลิต</span>
                                </div>
                                <select class="form-control">
                                <option disabled selected>++เลือกปี++</option>
                                <option *ngFor="let item of yearid">{{ item.yearlb }}</option>
                                </select>
                            </div>
                            </div> -->
                            <div class="col-3">
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">เลือก</span>
                                    </div>
                                    <select class="form-control" (change)="selectbyzone($event);">
                                        <option disabled selected>++โซน++</option>
                                        <option *ngFor="let item of supzone">{{ item.supzone }}</option>
                                    </select>
                                </div>
                            </div> 
                            <div class="col-3"> 
                                <button class="btn btn-outline-success" (click)="Loaddata1()"><i class="far fa-file-excel"></i> รายการขอเกี้ยว66/67 </button>
                                <!--<button type="button" class="btn btn-tool" (click)="downloadExcel_alldata();">ทดสอบ</button>-->                               
                            </div>
                            <!-- <div class="col-6">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                <span class="input-group-text"><i class="fas fa-search"></i></span>
                                </div>
                                <input class="form-control" placeholder="ป้อนค้นหา">
                            </div>
                            </div> -->
                        </div>
                        <div class="card-body table-responsive p-0" style="height: 600px;">
                            <table #tb_finance  id="tb_finance" class="table table-head-fixed text-nowrap">
                                <thead>
                                    <tr class="text-center">
                                        <th scope="col" colspan="3"></th>
                                        <th scope="col" colspan="4">จำนวนคำขอ</th>
                                        <th scope="col" colspan="2">ขอแล้ว(แปลง)</th>
                                        <th scope="col" colspan="2">%การขอ</th>
            
                                    </tr> 
                                    <tr class="headText headTableYellow text-right">
                                        <th class="headTableBlue text-left">เขต</th>
                                        <th class="text-left">นสส.</th>
                                        <th class="text-left">ชื่อ</th>
                                        <th>จำนวนคำขอทั้งหมด</th>
                                        <th>รอเข้าระบบสินเชื่อ</th>
                                        <th>อยู่ขั้นตอนสินเชื่อ</th>
                                        <th>อนุมัติแล้ว</th>
                                        <!--<th>รายการค่าปลูกอ้อยใหม่/ตอ</th>-->
                                        <th>แปลงอ้อยใหม่</th>
                                        <th>แปลงอ้อยตอ</th>
                                        <th>%อ้อยใหม่</th>
                                        <th>%อ้อยตอ</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="text-right" *ngFor="let item of filterbyzone"
                                        [ngStyle]="{'background-color':
                                        (item.supname == 'total-supzone' && item.supzone !== 'total-brd') ? '#FDF4DA' :
                                        (item.supname == 'total-supzone' && item.supzone == 'total-brd') ? '#56DAFE' : null}">
                                        <td class="text-left">{{ item.supcode }}</td>
                                        <td class="text-left">{{ item.supzone }}</td>
                                        <td class="text-left">{{ item.supname }}</td>
                                        <td>{{ item.cntFn | number: '1.0-0' }}</td>
                                        <td>{{ item.cntZonestep | number: '1.0-0' }}</td>
                                        <td>{{ item.cntFnstep | number: '1.0-0' }}</td>
                                        <td>{{ item.cntFned | number: '1.0-0' }}</td>
                                        <!--<td>{{ item.cntFnGrow | number: '1.0-0' }}</td>-->
                                        <td>{{ item.cntFnGrowa1 | number: '1.0-0' }}</td>
                                        <td>{{ item.cntFnGrowa2 | number: '1.0-0' }}</td>
                                        <td>{{ item.pcPlotnew | number }}</td>
                                        <td>{{ item.pcPlotold | number }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="card-footer">                
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div class="container-fluid">
    
        <!-- <div class="row">
            <div class="col-12 col-sm-6 col-md-3">
            <div class="info-box">
                <span class="info-box-icon bg-warning elevation-1">
                <i class="fas fa-file-upload"></i>
                </span>
                <div class="info-box-content">
                <span class="info-box-text headText">จำนวนคำขอเกี้ยวทั้งหมด</span>
                <span class="info-box-number headText3">
                    12,345 <small>รายการ</small> 1,234,567.59 <small>บาท</small>
                </span>
                </div>
            </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
            <div class="info-box mb-3">
                <span class="info-box-icon bg-success elevation-1"><i class="fas fa-thumbs-up"></i></span>
    
                <div class="info-box-content">
                <span class="info-box-text headText">จำนวนคำขอที่อนุมัติแล้ว</span>
                <span class="info-box-number headText3">
                    2,345 <small>รายการ</small> 234,567.59 <small>บาท</small>
                </span>
                </div>
            </div>
            </div>
    
            <div class="col-12 col-sm-6 col-md-3">
            <div class="info-box mb-3">
                <span class="info-box-icon bg-secondary elevation-1"><i class="fas fa-chalkboard-teacher"></i></span>
    
                <div class="info-box-content">
                <span class="info-box-text headText">จำนวนคำขอในขั้นตอนสินเชื่อ</span>
                <span class="info-box-number headText3">
                    2,345 <small>รายการ</small> 234,567.59 <small>บาท</small>
                </span>
                </div>
            </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
            <div class="info-box mb-3">
                <span class="info-box-icon bg-warning elevation-1"><i class="fas fa-clock"></i></span>
    
                <div class="info-box-content">
                <span class="info-box-text headText">จำนวนคำขอจากเขต</span>
                <span class="info-box-number headText3">
                    2,345 <small>รายการ</small> 234,567.59 <small>บาท</small>
                </span>
                </div>
            </div>
            </div>
        </div> -->    
    </div>  
  </section>
</div>

  
<app-footer></app-footer>